import { render } from "./LogoList.vue?vue&type=template&id=c76a5d50&scoped=true"
import script from "./LogoList.vue?vue&type=script&lang=js"
export * from "./LogoList.vue?vue&type=script&lang=js"

import "./LogoList.vue?vue&type=style&index=0&id=c76a5d50&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c76a5d50"]])

export default __exports__